import React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { imgBase64 } from "../imgBase64/ImgBase64";
import { columnGrid } from "./ColumnGrid";
import Tooltip from '@mui/material/Tooltip';
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "setup";
import { getUserByToken } from "app/helpers/getUserByToken";
import { saveOldRowChangeMinute } from "app/pages/minutas/minutaFood/services/update-minuta/update-minuta.service";
import { getLStorage, getSStorage } from "global.d";
import { parseNnumber } from "app/pages/minutas/minutaFood/services/serviceMinutaFood/serviceMinutaFood";
import { warn, error as toastError, success } from '../../utils/customToasd'
import { callSP } from '../../../setup/axios/AxiosCallSP'
import { Loading } from "../loadingR/Loading";
import { ModalForm } from '../../utils/modal/ModalForm'
import { position } from "_metronic/assets/bootstrap/js/dist/dom/manipulator";
const logAndReturn = (value: string, column: any, row: any) => {
    return value;
};
const RowsGrid: FC<RowsGridProps> = (props) => {
    const vMinuta: number = getLStorage('version');

    const [inputs, setInputs] = useState<any>()

    const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)
    const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
    const [ponderado, setPonderado] = useState<number>()
    const [comensales, setComensales] = useState<number>()
    const [diasSemana, setDiasSemana] = useState<any>()
    const [ponderados, setPonderados] = useState<Record<string, string | number>>({});
    const [showModalDetail, setShowModalDetail] = useState(false)
    const [initialComensalesModal, setInitialComensalesModal] = useState<any>({
        Lunes: "", Martes: "", Miercoles: "", Jueves: "", Viernes: "", "Sábado": "", Domingo: ""
    })
    const [load, setLoad] = React.useState(false)
    const clearedSwapSet = useMemo(() => new Set((props.clearedSwapCoords ?? []).map(String)), [props.clearedSwapCoords])

    const buildInitialPonderados = () => {
        const initialPonderados: any = {};
        props.rows?.forEach((row: any, key2: number) => {
            props.column?.forEach((column) => {
                if (column.type === "number" && !props.textPonderado) {
                    const key = `${key2}_${column.id}`;
                    initialPonderados[key] = parseFloat(row[column.key]) || 0;
                }
            });
        });
        return initialPonderados;
    };
    const [dataComensales, setDataComensales] = useState<Record<string, number | string>>({});

    const buildInitialComensales = () => {
        const initialComensales: Record<string, number> = {};
        props.rows?.forEach((row: any, key2: number) => {
            props.column?.forEach((column) => {
                if (props.textPonderado === false && row.nombreEstructura === "Comensales" && column.dataFecha === undefined) {
                    const key = `cantidad_comensales${column.id}`;
                    initialComensales[key] = !row[key] ? 0 : row[key];
                    initialComensales[key] = !row[key] ? 0 : row[key];
                }
            });
        });
        return initialComensales;
    };
    useEffect(() => {
        setDataComensales(buildInitialComensales());
    }, [props.rows, props.column]);
    useEffect(() => {
        setPonderados(buildInitialPonderados());
    }, [props.rows, props.column]);
    let style: any = {};
    const porcentajeComensales = (id: number, ponderadoInicial: number) => {
        try {
            const comensal: any = document.getElementById("comensales" + id);
            const pond: number = ponderado || ponderadoInicial;
            const total = Math.round(parseFloat(comensal.value) * pond / 100);
            return total
        } catch (error) {
        }
    }
    useEffect(() => {
        if (comensales != undefined && ponderado != undefined) {
            porcentajeComensales(comensales, ponderado);
        }
    }, [ponderado, comensales])


    //all_data, fila, valor campo fila, campo columna, id fila
    async function blurPonderado(props: any, rowFila: any, event: any, colum: any, idRow: any, save: any, cantidad_dias_minuta: any) {
        console.log("blurPonderado");

        let totalPonderado = 0
        const newData = props.rows.map((itemColumn: any, key: number) => {
            if (key === idRow) {
                itemColumn['ctoPlatoPonderado' + colum] = parseNnumber(
                    itemColumn['ctoPlatoPonderado' + colum]
                )
                itemColumn['cto_plato' + colum] = parseNnumber(itemColumn['cto_plato' + colum])
                itemColumn['ponderado' + colum] = parseNnumber(itemColumn['ponderado' + colum])
                itemColumn['ctoPlatoPonderado' + colum] = Number(
                    (
                        (props.rows[idRow]['cto_plato' + colum] * parseInt(event.target.value)) /
                        100
                    ).toFixed(2)
                )
                if (key > 3 && itemColumn['ctoPlatoPonderado' + colum] !== undefined) {
                    if (isNaN(itemColumn['ctoPlatoPonderado' + colum])) {
                        itemColumn['ctoPlatoPonderado' + colum] = 0
                    }
                    totalPonderado += itemColumn['ctoPlatoPonderado' + colum]
                }
                return itemColumn
            } else {
                itemColumn['ctoPlatoPonderado' + colum] = parseNnumber(
                    itemColumn['ctoPlatoPonderado' + colum]
                )
                itemColumn['cto_plato' + colum] = parseNnumber(itemColumn['cto_plato' + colum])
                if (key > 3 && itemColumn['ctoPlatoPonderado' + colum] !== undefined) {
                    totalPonderado = parseFloat(parseFloat(totalPonderado.toString()).toFixed(2))
                    totalPonderado += itemColumn['ctoPlatoPonderado' + colum]
                }
            }
            return itemColumn
        })

        let totalPlatoPonderado = 0
        let totalFilas = 0

        // Validar que newData tenga los elementos necesarios
        if (!newData || newData.length < 3 || !newData[0] || !newData[1] || !newData[2]) {
            return
        }

        newData[1]['ctoPlatoPonderado' + colum] = Number(Number(totalPonderado).toFixed(2))
        newData[2]['ctoPlatoPonderado' + colum] = Number(
            (
                newData[1]['ctoPlatoPonderado' + colum] - newData[0]['ctoPlatoPonderado' + colum]
            ).toFixed(2)
        )
        const itemColumn = newData[idRow]
        if (!itemColumn || !newData[1]) {
            return
        }
        Object.keys(newData[1]).map((item) => {
            if (item.indexOf('ctoPlatoPonderado') > -1) {
                if (typeof newData[1][item] === 'string') {
                    newData[1][item] = parseFloat(newData[1][item])
                }
                totalPlatoPonderado += newData[1][item]
            }
            if (item.includes('fecha')) {
                totalFilas++
            }
        })
        const costoTotal = totalFilas > 0 ? (totalPlatoPonderado / totalFilas).toFixed(2) : '0'

        const costoProm: any = document.getElementById('costoProm')
        if (costoProm && costoProm !== null) {
          costoProm.innerHTML = `${costoTotal}`
        }


        const sessionData = getSStorage('dataMinutaSession')
        const sessionParse: any = JSON.parse(sessionData)

        let idEstructura = 0
        for (let index = 0; index < cantidad_dias_minuta; index++) {
            if (rowFila["idEstructura" + index] != undefined) {
                idEstructura = rowFila["idEstructura" + index]
                break
            }
        }
        if (save) {
            setLoad(true)
            // fija = 1 cuando es Estructura Fija, 0 cuando es normal (mismo criterio que edición individual en MinutaFood)
            const idGrupo = Number(rowFila?.['id_grupo_estructura' + colum] ?? 0)
            const esFijaPorGrupo = idGrupo !== 0
            const nombreNorm = (rowFila?.nombreEstructura && String(rowFila.nombreEstructura).toLowerCase().trim()) || ''
            const esFijaPorNombre = nombreNorm === 'estructura fija' || nombreNorm.includes('estructura fija')
            const valorFija = (esFijaPorGrupo || esFijaPorNombre) ? '1' : '0'
            const respValidacionMinuta: any = await callSP('amd_setSesionMinuta', [
                { text: 'cmd', value: "update_ponderacion_estructura" },
                { text: 'usuario', value: user.idUser + "" },
                { text: 'id_session', value: sessionParse.id_session + "" },
                { text: 'ponderacion', value: event.target.value + "" },
                { text: 'fija', value: valorFija },
                { text: 'id_estructura', value: idEstructura + "" },
                { text: 'versionMinuta', value: vMinuta + "" },
                { text: 'costo', value: document.getElementById('costoProm')?.innerHTML }
            ])

            setTimeout(() => {
                document.getElementById('ocultar_todo')?.click();
                document.getElementById('mostrar_todo')?.click();
            }, 1000);

            setLoad(false)
        }
    }
    let grupo_estructuras: any = []
    let array_ids_grupo_Est: any = []

    grupo_estructuras = getSStorage('dataEstructuraMasivo')
    let stateMinuta: any = JSON.parse(getLStorage('stateMinuta'))

    grupo_estructuras?.forEach((est: any, key2: number) => {
        if (est.id_cliente == stateMinuta.state.params.ceco) {
            array_ids_grupo_Est.push(est.id)
        }

    })

    async function setComensalesByDias(dias_value: any, propsTabla: any) {
        try {
            const data_rows = propsTabla.rowsGridProps.rows
            const columns = propsTabla.rowsGridProps.column || []

            // Mapeo abreviación columna → nombre día (fotmatDateHeader genera "Lu", "Ma", "Mi", "Ju", "Vi", "Sá", "Do")
            const abrevToDia: any = {
                "Lu": "Lunes", "Ma": "Martes", "Mi": "Miercoles",
                "Ju": "Jueves", "Vi": "Viernes", "Sá": "Sábado", "Do": "Domingo"
            }
            const diaMap: any = {
                "Lunes": 1, "Martes": 2, "Miercoles": 3, "Jueves": 4,
                "Viernes": 5, "Sábado": 6, "Domingo": 7
            }

            // 1. Encontrar fila de Comensales y su índice
            let comensalesRowIndex = -1
            let comensalesRow: any = null
            data_rows.forEach((row: any, idx: number) => {
                if (row.nombreEstructura === "Comensales" && row['cabecera'] === true) {
                    comensalesRowIndex = idx
                    comensalesRow = row
                }
            })

            // 2. Mapear columnas de fecha a días de la semana
            const columnsByDia: any = {}
            columns.forEach((col: any, colIdx: number) => {
                if (col.dataFecha !== undefined) {
                    const abrev = col.text?.substring(0, 2)
                    const diaNombre = abrevToDia[abrev]
                    if (diaNombre) {
                        if (!columnsByDia[diaNombre]) columnsByDia[diaNombre] = []
                        columnsByDia[diaNombre].push({ column: col, colIdx })
                    }
                }
            })

            // 3. Actualizar comensales en la sesión (SP por cada día)
            const sessionData = getSStorage('dataMinutaSession')
            const sessionParse: any = JSON.parse(sessionData)
            const arra_dias: any = []
            const dias_valor: any = []

            for (const [dia, num] of Object.entries(diaMap)) {
                const valor = dias_value[dia]
                const valorStr = valor !== undefined && valor !== null && valor !== "" ? String(valor) : ""
                if (valorStr !== "") {
                    arra_dias.push(String(num))
                    dias_valor.push(valorStr)

                    await callSP('amd_setSesionMinuta', [
                        { text: 'cmd', value: "update_comensales_dia" },
                        { text: 'usuario', value: user.idUser + "" },
                        { text: 'id_session', value: sessionParse.id_session + "" },
                        { text: 'versionMinuta', value: vMinuta + "" },
                        { text: 'comensales', value: valorStr },
                        { text: 'dia_semana', value: String(num) }
                    ])
                }
            }

            // 4. Actualizar comensales en el contrato
            const idContrato = getSStorage("idContrato")
            if (arra_dias.length > 0) {
                await callSP('amd_updateComesalesContrato', [
                    { text: 'contrato', value: idContrato + "" },
                    { text: 'dia_semana', value: arra_dias.join(",") },
                    { text: 'comensales', value: dias_valor.join(",") },
                ])
            }

            // 5. Para cada columna de fecha afectada, actualizar comensales local y llamar blurComensales
            //    (mismo flujo que la edición inline para recalcular costos)
            if (comensalesRow && props.blurComensales) {
                for (const [dia, colInfos] of Object.entries(columnsByDia) as any) {
                    const valor = dias_value[dia]
                    const valorStr = valor !== undefined && valor !== null && valor !== "" ? String(valor) : ""
                    if (valorStr === "") continue

                    for (const colInfo of colInfos) {
                        const col = colInfo.column
                        const oldValue = comensalesRow["cantidad_comensales" + col.id]
                        // Actualizar valor local (como lo hace el onBlur inline)
                        comensalesRow["cantidad_comensales" + col.id] = valorStr

                        const edited = String(oldValue) !== valorStr
                        if (edited) {
                            saveOldRowChangeMinute(comensalesRowIndex, comensalesRow)
                        }

                        // Llamar blurComensales igual que la edición inline
                        const fakeEvent = { target: { value: valorStr } } as any
                        props.blurComensales!(fakeEvent, data_rows, col, comensalesRowIndex, colInfo.colIdx, comensalesRow, edited)

                        // Esperar para no saturar las llamadas
                        await new Promise(r => setTimeout(r, 300))
                    }
                }
            }

            success('Comensales actualizados correctamente')
            setShowModalDetail(false)
            setTimeout(() => {
                window.location.reload()
            }, 2000)
        } catch (err: any) {
            console.error("Error en setComensalesByDias:", err);
            toastError('Error al guardar comensales: ' + (err?.message || err))
        }
    }

    function setColorModificado(props: any) {
        if (props.rows.length > 0) {
            let cantidad_dias_minuta = 0
            for (let index = 0; index < 100; index++) {
                if (props.rows[0]["id_receta" + index] == undefined) {
                    break
                }
                cantidad_dias_minuta++
            }

            for (let index = 0; index < props.rows.length; index++) {
                if (!props.rows[index]) continue
                if (!props.rows[index].cabecera) {
                    for (let index2 = 0; index2 < cantidad_dias_minuta; index2++) {
                        if (props.rows[index]["modificado" + index2] == 1) {
                            const _receta: any = document.getElementById("receta_" + index + "_" + index2);
                            // Verificar que el elemento existe antes de modificar su estilo
                            if (_receta) {
                                _receta.style.backgroundColor = '#7eacf7'
                            }
                        }
                    }
                }
            }
        }


    }

    // Mover setTimeout a useEffect con cleanup para evitar errores cuando el componente se desmonta
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setColorModificado(props)
        }, 1000);

        // Cleanup: cancelar el timeout si el componente se desmonta
        return () => {
            clearTimeout(timeoutId);
        };
    }, [props]);

    const readonly = vMinuta != 2 && vMinuta != 3 ? true : false;
    const readonly3 = vMinuta != 2 && vMinuta != 3 ? true : false;
    return (
        <tbody>
            <Loading open={load} />
            {props.rows?.map((row: any, key2: number) => {

                let addClass = "";
                let fechaRow = "";
                let cambiaColor = '';
                let openModal = true;
                return (
                    <tr key={key2} >
                        {(props.isCheckbox) ?
                            <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                    <input
                                        className='form-check-input widget-13-check'
                                        type='checkbox'
                                        value='1'
                                        defaultChecked={row?.checked}
                                        checked={row?.checked}
                                    />
                                </div>
                            </td> : null}
                        {
                            props.column?.map((column: any, key: number) => {
                                let fijo = "";
                                let cont;
                                const result = row['change' + row["key" + column.id]];
                                const cond = result !== undefined ? result[row["fecha" + column.id]] : undefined;
                                const length = column.hideColumn ? column.hideColumn.length : 0;
                                if (column.key === "nombreEstructura" || length > 0) {
                                    fijo = " colum-fecha";
                                }
                                if (cond !== undefined) {
                                    if (column.key !== "nombreEstructura")
                                        cambiaColor = " ultimo-cambio-minuta";
                                } else {
                                    cambiaColor = '';
                                }
                                let firstColumn = "";
                                if (key === 1) {
                                    //firstColumn = " first-col";
                                }
                                if (key > 1) {
                                    firstColumn = " ancho-fila";
                                }
                                if (column.key === "nombreEstructura") {
                                    const colorLable = (props.isMinutaFood ? "label-minuta-food" : "label-minuta-vertical")
                                    fijo = " colum-fija2 " + colorLable;

                                }
                                const num = row["RecFija" + column.id];
                                if (num > 0) {
                                    addClass = " receta-fija ";
                                    fechaRow = row["fecha" + column.id];
                                }
                                let claseRectaFija = "";
                                if (fechaRow === column.text) {
                                    claseRectaFija = addClass;
                                } else {

                                }
                                let classRow = column.classNameRow + fijo + firstColumn + claseRectaFija + cambiaColor;
                                if (row[column.key]?.text !== undefined && row[column.key] !== undefined) {
                                    return null;
                                }
                                else {
                                    let text = !props.normal || column.key === "nombreEstructura" ? row[column.key] ? row[column.key] : row[column.key] : "";
                                    if (row.cabecera && key > 0) {
                                        if (row.nombreEstructura === "Comensales" && column.dataFecha) {
                                            cont = row["cantidad_comensales" + column.id];
                                        } else if (column.key == ('cto_plato' + column.id)) {
                                            cont = '';
                                        } else if (row.nombreEstructura === "Diferencial" && column.dataFecha !== undefined) {
                                            let color = {};
                                            const diferencial = (props.rows[1]["ctoPlatoPonderado" + column.id] - props.rows[0]["ctoPlatoPonderado" + column.id])
                                            if (diferencial < 0) {
                                                color = { color: "green", fontWeight: "bold" };
                                            } else {
                                                if (diferencial != 0)
                                                    color = { color: "red", fontWeight: "bold" };
                                            }
                                            if (props.textPonderado === true && !isNaN(diferencial)) {
                                                cont = <span>{(diferencial ? diferencial.toString().replace(".", ",") : 0)}</span>
                                            } else
                                                cont = <span style={color}>{diferencial.toFixed(2)}</span>;
                                        } else if (row.nombreEstructura === "Costo Planificado" || row.nombreEstructura === "Costo Ajustado" || row.nombreEstructura === "Diferencial") {
                                            if (column.key == ("ponderado" + column.id)) {
                                                cont = "";
                                            } else {
                                                if (props.textPonderado === true && !isNaN(row['ctoPlatoPonderado' + column.id])) {
                                                    cont = <span>{(row['ctoPlatoPonderado' + column.id] ? row['ctoPlatoPonderado' + column.id].toString().replace(".", ",") : 0)}</span>
                                                } else
                                                    cont = row['ctoPlatoPonderado' + column.id];
                                            }
                                            openModal = false
                                        } else if (row.nombreEstructura === "Costo Ajustado" && (column.text === "$ Plato Pond." || column.dataFecha)) {
                                            if (props.textPonderado === true && !isNaN(row['ctoPlatoPonderado' + column.id])) {
                                                cont = <span>{(row['ctoPlatoPonderado' + column.id] ? row['ctoPlatoPonderado' + column.id].toString().replace(".", ",") : 0)}</span>
                                            } else
                                                cont = row['ctoPlatoPonderado' + column.id];
                                        }
                                        else if ((column.text === "$ Plato Pond." || column.dataFecha)) {
                                            let color = { color: "green", fontWeight: "bold" };
                                            if (row['ctoPlatoPonderado' + column.id] < 0) {
                                                color = { color: "red", fontWeight: "bold" };
                                            }
                                            if (props.textPonderado === true && !isNaN(row['ctoPlatoPonderado' + column.id])) {
                                                cont = <span>{(row['ctoPlatoPonderado' + column.id] ? row['ctoPlatoPonderado' + column.id].toString().replace(".", ",") : 0)}</span>
                                            } else
                                                cont = <span style={color}>{row['ctoPlatoPonderado' + column.id]}</span>;
                                        }
                                        else if (row.nombreEstructura === "Comensales" && column.dataFecha === undefined) {
                                            // (props.textPonderado === true && !isNaN(row[column.key])) ? row[column.key] = (row[column.key] ? row[column.key].toString().replace(".", ",") : 0) : <></>;
                                            if (props.textPonderado === true && !isNaN(row[column.key])) {
                                                cont = <span>{(row[column.key] ? row[column.key].toString().replace(".", ",") : 0)}</span>
                                            } else {


                                                cont = <input type="number" className="form-control3" id={"comensales" + column.id}
                                                    style={{
                                                        height: "0px",
                                                        width: "70px"
                                                    }}
                                                    value={dataComensales[`cantidad_comensales${column.id}`] || ''}
                                                    onChange={(event) => {
                                                        const newValue = parseInt(event.target.value || "0");
                                                        setDataComensales(prev => ({
                                                            ...prev,
                                                            [`cantidad_comensales${column.id}`]: newValue.toString()
                                                        }));
                                                    }}
                                                    readOnly={readonly}
                                                    onBlur={(event) => {
                                                        if (event.target.value === '') {
                                                            setDataComensales(prev => ({
                                                                ...prev,
                                                                [`cantidad_comensales${column.id}`]: '0'
                                                            }));
                                                        }
                                                        const value = parseInt(event.target.value);
                                                        if (value < 0 && value > 9999) {
                                                            event.target.value = "0";
                                                        } else {
                                                            const edit: boolean = event.target.value != row["cantidad_comensales" + column.id];
                                                            if (edit)
                                                                saveOldRowChangeMinute(key2, row);
                                                            row["cantidad_comensales" + column.id] = event.target.value;
                                                            return props.blurComensales ? props.blurComensales(event, props.rows, column, key2, key, row, edit) : null;
                                                        }
                                                    }}></input>;
                                            }
                                        } else {
                                            cont = 0;
                                            openModal = true
                                        }


                                    } else {
                                        let readonly2 = false;
                                        let readonly = false;
                                        if (vMinuta != 2 && vMinuta != 3) {
                                            readonly2 = true;
                                        } else {

                                            readonly = row['receta' + column.id] ? false : column.text.toLowerCase().includes("plato") ? false : true;
                                        }
                                        (props.textPonderado === true) ? cont = (readonly ? 0 : row[column.key] ? row[column.key].toString().replace(".", ",") : 0) : <></>;
                                        if (props.textPonderado === true && !isNaN(row[column.key])) { row[column.key] = cont; }
                                        (column.type === "number" && !props.textPonderado) ? (
                                            cont = <>
                                                <Tooltip title={<h4 style={{ color: "#fff" }}>{(!ponderado || !comensales) ? 0 : porcentajeComensales(column.id, (Number(dataComensales[key2 + "_" + column.id]) || 0))}</h4>} arrow>
                                                    <input
                                                        id={"ponderado" + key2 + "_" + column.id}
                                                        type="number"
                                                        className="form-control2"
                                                        readOnly={readonly2 || readonly}
                                                        value={readonly ? 0 : ponderados[key2 + "_" + column.id] || '0'}
                                                        onKeyUp={(event: any) => {
                                                            const comensal: any = document.getElementById("comensales" + column.id);
                                                            setComensales(comensal.value);
                                                            setPonderado(Math.max(0, parseFloat(event.target.value)));
                                                        }}
                                                        onChange={(event) => {
                                                            const newValue = parseInt(event.target.value || "0");
                                                            setPonderados(prevPonderados => ({
                                                                ...prevPonderados,
                                                                [key2 + "_" + column.id]: newValue.toString()
                                                            }));
                                                        }}
                                                        onKeyDown={(event: any) => {
                                                            const comensal: any = document.getElementById("comensales" + column.id);
                                                            setComensales(comensal.value);
                                                            setPonderado(Math.max(0, parseFloat(event.target.value)));
                                                        }}
                                                        onMouseOver={(event: any) => {
                                                            const comensal: any = document.getElementById("comensales" + column.id);
                                                            setComensales(comensal.value);
                                                            setPonderado(Math.max(0, parseFloat(event.target.value)));
                                                        }}
                                                        onBlur={(event) => {
                                                            let value = parseFloat(event.target.value);
                                                            if (isNaN(value) || value < 0) {
                                                                value = 0;
                                                            }
                                                            const edit: boolean = value != row[column.key];
                                                            if (edit)
                                                                saveOldRowChangeMinute(key2, row);
                                                            event.target.value = value.toString();
                                                            const comensal: any = document.getElementById("comensales" + column.id);
                                                            setComensales(comensal.value);
                                                            setPonderado(value);
                                                            row[column.key] = value;
                                                            return props.blurPonderado ? props.blurPonderado(event, props.rows, column, key2, key, row, edit) : null;
                                                        }}
                                                    ></input>
                                                </Tooltip>
                                            </>
                                        ) :
                                            (column.type !== "button") ?
                                                cont = <>
                                                    <a href='#' className={'text-dark fw-bolder text-hover-primary d-inline' + addClass.trim() + "22 "}
                                                        onClick={async (event) => {
                                                            let data: any = {};
                                                            if (event.currentTarget.className.includes("receta-fija22")) {
                                                                if (row["RecFija" + column.id] > 0)
                                                                    data["alertaRecetaFija"] = true;
                                                            }
                                                            if (!column.showModalItem) {
                                                                return
                                                            }
                                                            Object.keys(row).map((item: any) => {
                                                                if (item.includes(column.id) || item === "nombreEstructura") {
                                                                    data[item] = row[item]
                                                                }
                                                            })
                                                            const user: any = await getUserByToken(accessToken);
                                                            if (user.role !== 10 && (row['receta' + column.id] !== "" || row["openEstrucuraRelacional" + column.id])) {
                                                                return props.openModal ? props.openModal(data, column, key2) : null
                                                            }
                                                        }}
                                                    >
                                                        {/* Condicional  */}
                                                        <Tooltip title={<h4 style={{ color: "#fff" }}>{!props.isMinutaFood ? text : row['receta' + column.id] || column.text == "Estructura servicios" ? text : '--'}</h4>} arrow>
                                                            <span>
                                                                {!props.isMinutaFood ? text : row['receta' + column.id] || column.text == "Estructura servicios" ? text : column.text.toLowerCase().includes("plato") ? '0' : logAndReturn('--', column, row)}
                                                                {row.nombreEstructura == "Comensales" && row['cabecera'] == true ?

                                                                    <img
                                                                        style={{ width: '22px' }}
                                                                        src={'/amd-sodexo/media/icons/minutas/fileEarmark.svg'}
                                                                        alt='Editar Comensales'
                                                                        onClick={async (event) => {
                                                                            console.log(props);
                                                                            if (readonly3) {
                                                                                warn('Minuta en estado ' + vMinuta + '. No es posible editar comensales')
                                                                                return
                                                                            }
                                                                            const idContrato = getSStorage("idContrato")
                                                                            const respValidacionMinuta: any = await callSP('amd_getDiaSemanaByContrato', [
                                                                                { text: 'contrato', value: idContrato + "" },

                                                                            ])
                                                                            console.log(respValidacionMinuta.data.result);
                                                                            let obj_dias: any = {}
                                                                            let obj_comensales: any = {
                                                                                Lunes: "", Martes: "", Miercoles: "", Jueves: "", Viernes: "", "Sábado": "", Domingo: ""
                                                                            }
                                                                            respValidacionMinuta.data.result.forEach(function (dia: any) {
                                                                                const diaNombre = dia.dia === "Sabado" ? "Sábado" : dia.dia
                                                                                if (dia.estado == "1") {
                                                                                    obj_dias[dia.dia] = false
                                                                                    obj_comensales[diaNombre] = dia.q_comensales != null ? dia.q_comensales + "" : ""
                                                                                } else {
                                                                                    obj_dias[dia.dia] = true
                                                                                }
                                                                            });
                                                                            setInitialComensalesModal(obj_comensales)
                                                                            setInputs([
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Lunes',
                                                                                    campo: 'Lunes',
                                                                                    placeholder: 'Comensales Lunes',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Lunes"],

                                                                                },
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Martes',
                                                                                    campo: 'Martes',
                                                                                    placeholder: 'Comensales Martes',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Martes"],

                                                                                },
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Miercoles',
                                                                                    campo: 'Miercoles',
                                                                                    placeholder: 'Comensales Miercoles',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Miercoles"],

                                                                                },
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Jueves',
                                                                                    campo: 'Jueves',
                                                                                    placeholder: 'Comensales Jueves',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Jueves"],

                                                                                },
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Viernes',
                                                                                    campo: 'Viernes',
                                                                                    placeholder: 'Comensales Viernes',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Viernes"],

                                                                                },
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Sábado',
                                                                                    campo: 'Sábado',
                                                                                    placeholder: 'Comensales Sábado',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Sabado"],

                                                                                },
                                                                                {
                                                                                    type: 'number',
                                                                                    label: 'Domingo',
                                                                                    campo: 'Domingo',
                                                                                    placeholder: 'Comensales Domingo',
                                                                                    className: 'input-ponderacion',
                                                                                    disabled: false,
                                                                                    hideInput: obj_dias["Domingo"],

                                                                                }
                                                                            ])
                                                                            console.log(obj_dias);
                                                                            setDiasSemana(obj_dias)
                                                                            setShowModalDetail(true)
                                                                        }}
                                                                    />
                                                                    : ""}
                                                                {column.text == "Estructura servicios" && row['cabecera'] == false
                                                                    && array_ids_grupo_Est.indexOf(row["estructura_padre"]) != -1
                                                                    && props.isMinutaVertical == false ?
                                                                    <input
                                                                        type="number"
                                                                        id={"ponderado_head_" + key2 + "_" + column.id}
                                                                        className="form-control2 _form-control"
                                                                        readOnly={readonly3}
                                                                        //value={5}
                                                                        style={{ borderColor: 'lightgrey !important' }}
                                                                        onBlur={(event) => {
                                                                            console.log("row", row);
                                                                            console.log("props", props);
                                                                            console.log("event", event.target.value);
                                                                            if (readonly3) {
                                                                                warn('Minuta en estado ' + vMinuta + '. No es posible editar ponderados')
                                                                                return
                                                                            }
                                                                            let value = parseFloat(event.target.value);
                                                                            if (isNaN(value) || value < 0) {
                                                                                value = 0;
                                                                                console.log("nan o negativo");
                                                                                return
                                                                            }
                                                                            let cantidad_dias_minuta = 0
                                                                            for (let pos = 0; pos < props.rows.length; pos++) {
                                                                                if (props.rows[pos].nombreEstructura == row.nombreEstructura) {
                                                                                    for (let index = 0; index < 100; index++) {
                                                                                        if (row["id_receta" + index] == undefined) {
                                                                                            break
                                                                                        }
                                                                                        cantidad_dias_minuta++
                                                                                        row["ponderaciones" + index] = event.target.value
                                                                                        row["ponderado" + index] = event.target.value
                                                                                        let ponderado: any = document.getElementById("ponderado" + pos + "_" + index);
                                                                                        if (ponderado != null) {
                                                                                            ponderado.value = event.target.value
                                                                                        }
                                                                                    }
                                                                                    break
                                                                                }
                                                                            };

                                                                            setPonderado(Math.max(0, parseFloat(event.target.value)));
                                                                            console.log(cantidad_dias_minuta);
                                                                            let save_data = false
                                                                            for (let index = 0; index < cantidad_dias_minuta; index++) {
                                                                                if (index == (cantidad_dias_minuta - 1)) {
                                                                                    save_data = true
                                                                                }
                                                                                blurPonderado(props, row, event, index, key2, save_data, cantidad_dias_minuta) //all_data, fila, valor campo fila, campo columna, id fila                                                                                
                                                                            }

                                                                        }}
                                                                    ></input> : ""}
                                                            </span>
                                                        </Tooltip>
                                                        {/* Visualización normal - color - $$$  */}

                                                        {column.key.includes("menu") && Object.keys(row).includes(`food${column.id}`) ? <img className="img-icon-table" src={"/amd-sodexo/media/icons/foods/" + row[`food${column.id}`]} alt='comida' /> : null} {/* Visualización íconos  */}
                                                        {column.key.includes("menu") && Object.keys(row).includes(`price${column.id}`) ? <img className="img-icon-table" src={"/amd-sodexo/media/icons/foods/" + row[`price${column.id}`]} alt='precio' /> : null} {/* Visualización íconos precio  */}

                                                    </a >
                                                    <span className='text-muted fw-bold text-muted d-block fs-7'>{row[column.key]?.subText || null}</span>
                                                </>
                                                :
                                                cont = row[column.key] ? <button onClick={() => {
                                                    let data: any = {};
                                                    Object.keys(row).map((item: any) => {
                                                        if (item.includes(column.id) || item === "nombreEstructura") {
                                                            data[item] = row[item]
                                                        }
                                                    })
                                                    return props.openModal ? props.openModal(data, column, key2) : null
                                                }} type="button" className="btn btn-link"><img src={imgBase64.save} /></button> : null;
                                    }
                                    style = {
                                        display: "",
                                        backgroundColor: "",
                                        color: ""
                                    }
                                    if (props.color && column.key !== "nombreEstructura") {
                                        if (props.colorSelected?.length === 0) {
                                            style.backgroundColor = row["color" + column.id];
                                        } else {
                                            if (props.colorSelected?.includes(row["color" + column.id])) {
                                                style.backgroundColor = row["color" + column.id];
                                            }
                                        }
                                    }
                                    if (column.style !== undefined) {
                                        style.display = column.style.display;
                                    }
                                    if (classRow.includes('receta-fija')) {
                                        style.backgroundColor = "#82D4DC";
                                        classRow = classRow.split('receta-fija').join('');
                                    }

                                    if (column.key === "nombreEstructura") {
                                        style.backgroundColor = `${row["colorGrupoEstructura"]}`;
                                        style.height = "calc(41.1px)";
                                        // style.position = "sticky"
                                        //style.left = "150px"
                                        // style.zIndex = "2"
                                    }

                                    if (key2 === 3 && props.isMinutaFood) {
                                        style.backgroundColor = "#DFDCDC";
                                    }
                                    const hasRecipeField = Object.prototype.hasOwnProperty.call(row || {}, `receta${column.id}`)
                                    const isRecipeCell = !row?.cabecera && column.key !== "nombreEstructura" && hasRecipeField
                                    if (isRecipeCell) {
                                        const coordKey = `${key2}-${column.id}`
                                        const isRowModified = row && row[`modificado${column.id}`] == 1
                                        if (isRowModified && !clearedSwapSet.has(coordKey)) {
                                            style.backgroundColor = '#7eacf7'
                                        }
                                    }
                                    let _id = ""
                                    if (column.hideColumn != undefined && !row.cabecera) {
                                        _id = "receta_" + key2 + "_" + column.id
                                        style.height = "calc(82.0px)";
                                    }
                                    classRow = classRow + " minuta-td";
                                    return (
                                        <td
                                            id={_id}
                                            style={style}
                                            key={column.key}
                                            className={`${classRow} -${column.key}`}>
                                            {cont}
                                            {props.icono && column.key !== "nombreEstructura" && row["icon" + column.id] && column.key.includes("receta") ? <><img className="img-icon-table" src={"/amd-sodexo/media/icons/foods/" + row["icon" + column.id]} /></> : null}
                                            {props.precio && column.key !== "nombreEstructura" && row["icono" + column.id] && column.key.includes("receta") ? <><img className="img-icon-table" src={"/amd-sodexo/media/icons/foods/" + row["icono" + column.id]} /></> : null}
                                        </td>
                                    )
                                }
                            })
                        }
                    </tr>)
            })}

            {showModalDetail && (
                <ModalForm
                    initialValues={initialComensalesModal}
                    show={showModalDetail}
                    showSave={true}
                    rowsGridProps={props}
                    save={(value, setFieldValue, formikProps, params, props) => {
                        console.log("Guardar");
                        console.log(props);
                        setComensalesByDias(value, props)
                    }}
                    close={() => {
                        setShowModalDetail(false)
                    }}
                    arrayInput={inputs}
                    title={'Dias Comensales'}
                />
            )}

        </tbody >


    )
}
interface RowsGridProps {
    rows?: any,
    column?: columnGrid[],
    allColumn?: any,
    isCheckbox?: boolean,
    colorSelected?: string[],
    clearedSwapCoords?: string[],
    openModal?(row: any, column: any, num: number): void,
    color?: boolean,
    icono?: boolean,
    normal?: boolean,
    textPonderado?: boolean,
    precio?: boolean,
    isMinutaVertical?: boolean,
    isMinutaFood?: boolean,
    blurPonderado?(event: React.FocusEvent<HTMLInputElement, Element>, row: any, column: any, idRow: number, idColum: number, rowItem?: any, saveEdit?: boolean): void,
    blurComensales?(event: React.FocusEvent<HTMLInputElement, Element>, row: any, column: any, idRow: number, idColum: number, rowItem?: any, saveEdit?: boolean): void,
    refreshData?(reload?: boolean): void
}
RowsGrid.defaultProps = {
    isMinutaVertical: false,
    textPonderado: false,
    colorSelected: []
}

export { RowsGrid }